'use client';

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { ChevronLeft, ChevronRight } from "lucide-react";

import PointsTiles, {
    type PointsTilesLayout,
    type PointsTilesTile,
} from "../points-tiles/PointsTiles";

type PointsTilesCarouselProps = {
    pointsData: PointsTilesTile[];

    /** Layout */
    classes?: string;
    autoHeight?: boolean;

    /** Swiper behaviour */
    infinite?: boolean;
    autoplay?: boolean;
    autoplayDelay?: number;

    /** Responsive slides */
    slidesPerView?: number;
    slidesPerViewMd?: number;
    slidesPerViewLg?: number;

    /** Passthrough to PointsTiles */
    pointsClasses?: string;
    pointTitleClasses?: string;
    tileLayout?: PointsTilesLayout;
};

// TODO THIS COMPONENT IS BROKEN AND NEEDS TO BE REWRITTEN
const PointsTilesCarousel = ({
                                 pointsData,
                                 classes = "",
                                 autoHeight = true,

                                 infinite = false,
                                 autoplay = false,
                                 autoplayDelay = 5000,

                                 slidesPerView = 1,
                                 slidesPerViewMd = 1,
                                 slidesPerViewLg = 1,

                                 pointsClasses,
                                 pointTitleClasses,
                                 tileLayout,
                             }: PointsTilesCarouselProps) => {
    const hasMultipleSlides = pointsData.length > 1;
    const resolvedTileLayout: PointsTilesLayout =
        tileLayout ||
        (slidesPerView > 1 || slidesPerViewMd > 1 || slidesPerViewLg > 1
            ? "stacked"
            : "responsive");

    return (
        <div className={`relative w-full ${classes}`}>
            <Swiper
                modules={[Navigation, Autoplay]}
                slidesPerView={slidesPerView}
                spaceBetween={30}
                speed={600}
                loop={hasMultipleSlides && infinite}
                autoHeight={autoHeight}
                allowTouchMove={hasMultipleSlides}
                navigation={
                    hasMultipleSlides
                        ? {
                            nextEl: ".points-tiles-next",
                            prevEl: ".points-tiles-prev",
                        }
                        : false
                }
                autoplay={
                    hasMultipleSlides && autoplay
                        ? {
                            delay: autoplayDelay,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        }
                        : false
                }
                breakpoints={{
                    768: {
                        slidesPerView: slidesPerViewMd,
                    },
                    1024: {
                        slidesPerView: slidesPerViewLg,
                    },
                }}
                className="points-tiles-swiper"
            >
                {pointsData.map((pointsGroup, index) => (
                    <SwiperSlide key={index}>
                        <PointsTiles
                            pointsData={[pointsGroup]}
                            variant="cards"
                            layout={resolvedTileLayout}
                            pointsClasses={pointsClasses}
                            pointTitleClasses={pointTitleClasses}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>

            {hasMultipleSlides && (
                <>
                    <button
                        className="points-tiles-prev absolute left-2 top-1/2 -translate-y-1/2 z-10
                                   flex h-[45px] w-[45px] items-center justify-center
                                   rounded-full bg-black/60 text-white
                                   hover:bg-black transition"
                        aria-label="Previous"
                    >
                        <ChevronLeft className="h-6 w-6" />
                    </button>

                    <button
                        className="points-tiles-next absolute right-2 top-1/2 -translate-y-1/2 z-10
                                   flex h-[45px] w-[45px] items-center justify-center
                                   rounded-full bg-black/60 text-white
                                   hover:bg-black transition"
                        aria-label="Next"
                    >
                        <ChevronRight className="h-6 w-6" />
                    </button>
                </>
            )}
        </div>
    );
};

export default PointsTilesCarousel;
